import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "../api/baseurl";
import { toast } from "react-toastify";
import { Modal, Button } from "react-bootstrap";
import "react-toastify/dist/ReactToastify.css";
import "./Spinner.css";
import "./hm-theme.css";

const CreateLocations = ({ isOpen, onRequestClose, locationId, companycode, companyId }) => {
  const navigate = useNavigate();
  const createUrl = "/api/geolocation/create";
  const updateUrl = `/api/geolocation/update`;
  const getLocationUrl = `/api/geolocation/${locationId}`;
  const token = JSON.parse(localStorage.getItem("data")).token;

  const [locations, setLocations] = useState({
    location: "",
    companyId: companyId,
  });

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (locationId) {
      const fetchLocations = async () => {
        setLoading(true);
        try {
          const response = await axios.get(getLocationUrl, {
            headers: { Authorization: `Bearer ${token}` },
          });
          setLocations({
            location: response.data.location,
            companyId: response.data.companyId,
          });
        } catch (error) {
          handleError(error);
        } finally {
          setLoading(false);
        }
      };
      fetchLocations();
    }
  }, [locationId, getLocationUrl, token]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    if (locations.location) {
      const url = locationId ? updateUrl : createUrl;
      const data = {
        location: locations.location,
        companyId: locations.companyId,
        ...(locationId && { id: locationId }),
      };

      axios({
        method: "post",
        url: url,
        data: data,
        headers: { Authorization: `Bearer ${token}` },
      })
        .then(() => {
          setLoading(false);
          onRequestClose();
          setLocations({ location: "", companyId: companyId });
          toast.success(locationId ? "Location updated successfully" : "Location added successfully");
        })
        .catch((error) => {
          setLoading(false);
          handleError(error);
        });
    } else {
      setLoading(false);
      toast.error("Please fill out all required fields.");
    }
  };

  function handleError(error) {
    if (error.response?.status === 401) {
      navigate(`/signin`);
      toast.error("Your session has expired. Please login.");
    } else {
      toast.error(error.response?.data?.message || error.message || "An error occurred.");
    }
  }

  function rhandle(e) {
    const { id, value } = e.target;
    setLocations((prevState) => ({
      ...prevState,
      [id]: value,
    }));
  }

  return (
    <Modal show={isOpen} onHide={onRequestClose} centered>
      <Modal.Header closeButton className="hm-card-header">
        <Modal.Title className="hm-card-title">
          <i className="material-icons">location_on</i>
          {locationId ? "Update Location" : "Add Location"}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="p-4">
        {loading && <div className="loading"></div>}
        <form onSubmit={handleSubmit}>
          {companycode && (
            <div className="mb-3">
              <label htmlFor="companyCode" className="form-label small fw-semibold">Company Code</label>
              <input
                className="form-control bg-light"
                id="companyCode"
                type="text"
                value={companycode}
                readOnly
              />
            </div>
          )}

          <div className="mb-4">
            <label htmlFor="location" className="form-label small fw-semibold">
              Location Name <span className="text-danger">*</span>
            </label>
            <input
              className="form-control"
              id="location"
              type="text"
              placeholder="e.g. Headquarters / Branch 1"
              value={locations.location}
              onChange={rhandle}
              required
            />
          </div>

          <div className="d-flex justify-content-end gap-2">
            <Button variant="secondary" className="rounded-pill px-4" onClick={onRequestClose} disabled={loading}>
              Cancel
            </Button>
            <button type="submit" className="btn-hm-primary" disabled={loading}>
              <i className="material-icons" style={{ fontSize: "1rem" }}>{locationId ? "edit" : "add_location"}</i>
              {locationId ? "Update Location" : "Save Location"}
            </button>
          </div>
        </form>
      </Modal.Body>
    </Modal>
  );
};

export default CreateLocations;
